var _rect, _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdfDrupal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.3335,
    y: 8.33341,
    width: 33.333,
    height: 23.333,
    rx: 3.33333,
    stroke: "#004AAD",
    strokeWidth: 3.33333,
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.3335 15.0001H36.6668",
    stroke: "#004AAD",
    strokeWidth: 3.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.16667,
    cy: 11.6667,
    r: 1.66667,
    fill: "#004AAD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfDrupal);
export default __webpack_public_path__ + "static/media/pdf-drupal.32dd56945b1761d4ceb648218e2fe94f.svg";
export { ForwardRef as ReactComponent };